import React, { useState } from 'react';

export function PKIToolbar({ onOpenTicTacToe, onOpenDrawing, currentSection, scrollProgress }) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(null); // 'minigames' or 'drawing'

  return (
    <div
      className="relative z-50 pointer-events-auto"
    >
      {/* Toolbar button */}
      <div
        className="w-10 h-10 sm:w-auto sm:h-auto inline-flex items-center justify-center rounded-full transition-all duration-200 pointer-events-auto cursor-pointer bg-white/80 hover:bg-white sm:bg-gray-200 sm:hover:bg-gray-300 sm:px-6 md:px-8 sm:py-4"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Toolbar schließen" : "Toolbar öffnen"}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-gray-600 sm:text-black">
          <circle cx="12" cy="5" r="2" fill="currentColor"/>
          <circle cx="12" cy="12" r="2" fill="currentColor"/>
          <circle cx="12" cy="19" r="2" fill="currentColor"/>
        </svg>
      </div>

      {/* Toolbar panel */}
      {isOpen && (
        <div className="absolute top-full mt-2 right-0 sm:top-auto sm:bottom-full sm:mt-0 sm:mb-16 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 bg-white rounded-3xl overflow-hidden transition-all duration-300 shadow-xl">
          <div className="w-72 sm:w-80">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <h3 className="text-lg font-bold bg-gradient-to-r from-blue-500 to-pink-500 bg-clip-text text-transparent">
                {activeTab === 'minigames' ? 'Minigames' : activeTab === 'drawing' ? 'Malen' : 'Live-Aktivitäten'}
              </h3>
              <button
                onClick={() => {
                  setIsOpen(false);
                  setActiveTab(null);
                }}
                className="text-gray-400 hover:text-black transition-colors"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              {!activeTab && (
                <div className="space-y-3">
                  {/* Minigames Button */}
                  <button
                    onClick={() => {
                      onOpenTicTacToe();
                      setIsOpen(false);
                    }}
                    className="w-full flex items-center gap-4 p-4 bg-gray-100 rounded-2xl hover:bg-gray-200 transition-all duration-300"
                  >
                    <div className="text-3xl">🎮</div>
                    <div className="text-left">
                      <div className="font-semibold text-black">Tic Tac Toe</div>
                      <div className="text-sm text-gray-500">Spiele gegen Chris</div>
                    </div>
                  </button>

                  {/* Drawing Button - Desktop only */}
                  {window.innerWidth >= 640 && (
                    <button
                      onClick={() => {
                        onOpenDrawing();
                        setIsOpen(false);
                      }}
                      className="w-full flex items-center gap-4 p-4 bg-gray-100 rounded-2xl hover:bg-gray-200 transition-all duration-300"
                    >
                      <div className="text-3xl">🎨</div>
                      <div className="text-left">
                        <div className="font-semibold text-black">Deine Leinwand</div>
                        <div className="text-sm text-gray-500">Zeichne Chris ein Bild</div>
                      </div>
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
